import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { ReactNode } from "react";

import AppDialog from "components/common/AppDialog";

interface DeleteJobConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  deleteData: boolean;
  onDeleteDataChange: (value: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  busy?: boolean;
}

/**
 * Shared confirmation for every job-delete action in Bots Management. The
 * checkbox wipes the job's whole S3 data folder (logs, matches files, error
 * screenshots, downloaded data) together with the DB rows.
 */
export default function DeleteJobConfirmDialog({
  open,
  title,
  message,
  deleteData,
  onDeleteDataChange,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  busy = false,
}: DeleteJobConfirmDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={() => !busy && onCancel()}
      title={title}
      actions={
        <>
          <Button onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={confirmDisabled || busy}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </>
      }
    >
      <Typography variant="body2">{message}</Typography>
      <FormControlLabel
        sx={{ mt: 1 }}
        control={
          <Checkbox
            checked={deleteData}
            onChange={(e) => onDeleteDataChange(e.target.checked)}
            size="small"
            disabled={busy}
          />
        }
        label="Also delete job's data from S3 (logs, matches, screenshots)"
      />
    </AppDialog>
  );
}
